import axios from 'axios'

const state = {
  employeeData: null,
  loading: false,
  error: null,
  lastFetched: null
}

const getters = {
  getEmployeeData: (state) => state.employeeData,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
  getLastFetched: (state) => state.lastFetched,
  
  // Getters untuk data spesifik
  getEmployeeName: (state) => state.employeeData?.nama || state.employeeData?.name || null,
  getEmployeeNip: (state) => state.employeeData?.nip || null,
  getEmployeeEmail: (state) => state.employeeData?.email || null,
  getEmployeeJabatan: (state) => state.employeeData?.jabatan || null,
  getEmployeeUnitKerja: (state) => state.employeeData?.unitKerja || state.employeeData?.perEselonDua || null,
  getEmployeePhoto: (state) => state.employeeData?.photo || null,
  
  // Check if data is stale (older than 5 minutes)
  isDataStale: (state) => {
    if (!state.lastFetched) return true
    const fiveMinutes = 5 * 60 * 1000
    return Date.now() - state.lastFetched > fiveMinutes
  }
}

const actions = {
  /**
   * Fetch employee data from API
   * @param {Object} options - { forceRefresh: boolean }
   */
  async fetchEmployeeData({ commit, getters }, options = {}) {
    // Don't fetch if data is fresh and not forcing refresh
    if (!options.forceRefresh && !getters.isDataStale && state.employeeData) {
      console.log('Using cached employee data')
      return state.employeeData
    }

    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      const baseUrl = process.env.VUE_APP_API_HOST || 'http://localhost:8020'

      if (!token) {
        throw new Error('No authentication token found')
      }

      console.log('Fetching employee data from API...')
      const response = await axios.get(`${baseUrl}/sdm/employee`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

      if (response.data) {
        commit('SET_EMPLOYEE_DATA', response.data)
        commit('SET_LAST_FETCHED', Date.now())
        console.log('Employee data fetched successfully:', response.data)
        return response.data
      } else {
        throw new Error('No data received from API')
      }
    } catch (error) {
      console.error('Error fetching employee data:', error)
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch employee data'
      commit('SET_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /**
   * Clear employee data from store
   */
  clearEmployeeData({ commit }) {
    commit('SET_EMPLOYEE_DATA', null)
    commit('SET_LAST_FETCHED', null)
    commit('SET_ERROR', null)
  },

  /**
   * Update specific employee field
   */
  updateEmployeeField({ commit }, { field, value }) {
    commit('UPDATE_FIELD', { field, value })
  }
}

const mutations = {
  SET_EMPLOYEE_DATA(state, data) {
    state.employeeData = data
  },

  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_LAST_FETCHED(state, timestamp) {
    state.lastFetched = timestamp
  },

  UPDATE_FIELD(state, { field, value }) {
    if (state.employeeData) {
      state.employeeData[field] = value
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
